import React from 'react';
import '../styles/Contact.css';
import '../styles/AppAgt.css';
import '../styles/PresentationHomogene.css';
import ImgContact from '../images/ContactSite2.jpg';
import Footer from '../components/Footer';

const Contact = () => {
    return (
        <div className='AppAgt'>
            {/* Titre simple sous le header */}
            <div className='contact-header-simple'>
                <h1 className='contact-main-title'>Contact</h1>
                <h2 className='contact-museum-title'>Amicale de la Gare de Trôo</h2>
                <p className='contact-main-description'>
                    Venez nous rendre visite ou contactez-nous pour plus d'informations
                </p>
            </div>

            {/* Section principale avec style de l'accueil */}
            <div className='Presentation'>
                {/* Informations de contact principales */}
                <div className='presentation-section'>
                    <div className='presentation-card contact-highlight'>
                        <div className='section-header contact-header'>
                            <h2 className='section-title'>📧 Nous Contacter</h2>
                        </div>
                        <div className='section-content'>
                            <div className='contact-grid-main contact-centered'>
                                <div className='contact-item primary'>
                                    <div className='contact-icon'>✉️</div>
                                    <div className='contact-info'>
                                        <h3>Email</h3>
                                        <div className='contact-time'>
                                            <a href="mailto:garedetroo@gmail.com" className='email-link'>
                                                garedetroo@gmail.com
                                            </a>
                                        </div>
                                        <p className='contact-desc'>Nous vous répondrons dans les meilleurs délais</p>
                                    </div>
                                </div>
                                
                                <div className='contact-item train'>
                                    <div className='contact-icon'>🏛️</div>
                                    <div className='contact-info'>
                                        <h3>Visite à la Gare</h3>
                                        <div className='contact-time'>Gare de Trôo, 41800 Trôo</div>
                                        <p className='contact-desc'>Consultez nos horaires d'ouverture</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Informations pratiques */}
                <div className='presentation-section'>
                    <div className='presentation-card'>
                        <div className='section-header'>
                            <h2 className='section-title'>💰 Tarifs & Services</h2>
                        </div>
                        <div className='section-content'>
                            <div className='contact-grid-main'>
                                <div className='contact-item primary'>
                                    <div className='contact-icon'>🎫</div>
                                    <div className='contact-info'>
                                        <h3>Tarif de la Visite</h3>
                                        <div className='contact-time'>2 € adultes</div>
                                        <p className='contact-desc'>Gratuit pour les enfants de moins de 10 ans accompagnés</p>
                                    </div>
                                </div>

                                <div className='contact-item primary'>
                                    <div className='contact-icon'>❤️</div>
                                    <div className='contact-info'>
                                        <h3>Carte Avantage</h3>
                                        <div className='contact-time'>adultes 2 € réductions pour les visites suivantes</div>
                                        <p className='contact-desc'>La carte vous est remise à la gare et vous permettra de bénéficier d'un tarif réduit pour visiter la grotte pétrifiante et la cave Yucca à Trôo</p>
                                    </div>
                                </div>                                
                                <div className='contact-item summer'>
                                    <div className='contact-icon'>☕</div>
                                    <div className='contact-info'>
                                        <h3>Buvette</h3>
                                        <div className='contact-time'>Pendant les heures d'ouverture</div>
                                        <p className='contact-desc'>Tables de pique-nique disponibles à l'extérieur</p>
                                    </div>
                                </div>
                                
                                <div className='contact-item train'>
                                    <div className='contact-icon'>🛍️</div>
                                    <div className='contact-info'>
                                        <h3>Boutique</h3>
                                        <div className='contact-time'>Souvenirs & Produits locaux</div>
                                        <p className='contact-desc'>Découvrez notre sélection d'articles</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Informations complémentaires */}
                <div className='presentation-section'>
                    <div className='presentation-card'>
                        <div className='section-header'>
                            <h2 className='section-title'>ℹ️ Informations Pratiques</h2>
                        </div>
                        <div className='section-content'>
                            <div className='info-highlight'>
                                <p className='info-text'>
                                    <strong>🕒 Horaires :</strong> Consultez l'onglet "Horaires" pour connaître nos créneaux d'ouverture
                                </p>
                                <p className='info-text'>
                                    <strong>🚗 Accès :</strong> La gare est facilement accessible en voiture avec parking gratuit
                                </p>
                                <p className='info-text'>
                                    <strong>👥 Groupes :</strong> Visites de groupe possibles sur rendez-vous. Nous contacter par Email
                                </p>
                                <p className='info-text'>
                                    <strong>🎯 Activités :</strong> Ateliers modélisme tous les mercredis après-midi.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <Footer />
        </div>
    );
};

export default Contact;